import { create } from "zustand";
import { hc } from "@/frontend/lib/hc";

interface SubscriptionState {
  balance: number;
  hasCredits: boolean;
  isLowBalance: boolean;
  hasActiveSubscription: boolean;
  trialEndsAt: string | null;
  isTrialActive: boolean;
  isLoading: boolean;
  lastFetchedOrgId: string | null;
  fetchStatus: (orgId: string) => Promise<void>;
  reset: () => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set, get) => ({
  balance: 0,
  hasCredits: false,
  isLowBalance: false,
  hasActiveSubscription: false,
  trialEndsAt: null,
  isTrialActive: false,
  isLoading: false,
  lastFetchedOrgId: null,

  fetchStatus: async (orgId: string) => {
    // Skip if we already fetched for this org
    if (get().lastFetchedOrgId === orgId && !get().isLoading) {
      return;
    }

    set({ isLoading: true });

    try {
      const response = await hc.api.billing[":orgId"]["credit-status"].$get({
        param: { orgId },
      });

      if (response.ok) {
        const data = await response.json();
        set({
          balance: data.balance,
          hasCredits: data.hasCredits,
          isLowBalance: data.isLowBalance,
          hasActiveSubscription: data.hasActiveSubscription,
          trialEndsAt: data.trialEndsAt,
          isTrialActive: data.isTrialActive,
          lastFetchedOrgId: orgId,
        });
      }
    } catch (error) {
      console.error("[SubscriptionStore] Error fetching status:", error);
    } finally {
      set({ isLoading: false });
    }
  },

  reset: () => {
    set({
      balance: 0,
      hasCredits: false,
      isLowBalance: false,
      hasActiveSubscription: false,
      trialEndsAt: null,
      isTrialActive: false,
      isLoading: false,
      lastFetchedOrgId: null,
    });
  },
}));
